import { useTranslation } from "react-i18next"
import { t } from "i18next"
import { RadioGroup } from "@/components/ui/radio-group"
import { RadioGroupItemCustom } from "@/modules/patients/agenda/teleconsultation/booking/components/radio-group-item"
import { Flexibility } from "@/types/__generated__/union-types"

type FlexibilityItem = {
  label: string
  value: Flexibility
}

const flexibilities: FlexibilityItem[] = [
  {
    label: t("scheduling.waitingRoom.priority.FLEXIBLE"),
    value: "FLEXIBLE",
  },
  {
    label: t("scheduling.waitingRoom.priority.NOT_EARLIER"),
    value: "NOT_EARLIER",
  },
  {
    label: t("scheduling.waitingRoom.priority.FIXED_TIME"),
    value: "FIXED_TIME",
  },
]

export const FlexibilityGroup = ({ onChange, value }: { value?: Flexibility; onChange: (e: Flexibility) => void }) => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-2" data-testid="flexibility">
      <label className="text-on-surface-subdued text-sm" data-testid="flexibility-label">
        {t("scheduling.waitingRoom.priority.flexibility")}
      </label>
      <RadioGroup
        defaultValue="FLEXIBLE"
        value={value}
        className="flex flex-wrap gap-2"
        data-testid="flexibility-group"
        onValueChange={onChange}>
        {flexibilities.map((flexibility) => {
          const { value, label } = flexibility
          return <RadioGroupItemCustom key={value} value={value} groupName="flexibility" label={label} />
        })}
      </RadioGroup>
    </div>
  )
}
